
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormInput } from './PaymentFormSection';
import { PaymentFormValues } from './types';

type PaypalFormProps = {
  form: UseFormReturn<PaymentFormValues>;
}

const PaypalForm: React.FC<PaypalFormProps> = ({ form }) => {
  return (
    <div className="space-y-4">
      <FormInput
        form={form}
        name="paypalEmail"
        label="PayPal Email"
        placeholder="your-email@example.com"
        type="email"
        description="Email associated with your PayPal account"
      />
      
      <FormInput
        form={form}
        name="paypalUsername"
        label="PayPal Username (Optional)"
        placeholder="@yourusername"
        description="Your PayPal username if you have one"
      />
    </div>
  );
};

export default PaypalForm;
